<template>
  <div>
    <button
      class="button button--primary"
      type="button"
      :disabled="hasNotifiedStaff || !order.externalOrderId"
      @click="$openModal('iAmHere')"
    >
      <span class="icon fa fa-map-marker-alt" />
      I Am Here
    </button>



    <modal
      name="iAmHere"
      modal-style="compact"
    >
      <div class="section center">
        <div
          v-if="hasNotifiedStaff"
          class="animation-slide-left"
        >
          <span class="icon icon--block icon--medium secondary far fa-check-circle primary" />

          <h2 class="title title--3">
            Thanks! Our host has been notified.
          </h2>

          <p class="extra-spacing">We'll see you soon.</p>

          <button
            type="button"
            class="button button--primary button--large button--auto-width"
            @click="$closeModal('iAmHere')"
          >
            Okay
          </button>
        </div>

        <validated-form
          v-else
          name="iAmHere"
          @valid-submit="notifyStaffGuestIsAtLocation"
        >
          <span class="icon icon--block icon--medium primary far fa-map-marker-alt" />

          <h2 class="title title--3">
            Let the host know you're here.
          </h2>

          <template v-if="checkInOptions">
            <div
              v-for="input in checkInOptions"
              :key="input.property"
            >
              <text-input
                v-model="details[input.property]"
                type="text"
                :label="input.displayName"
                :name="input.property"
                :placeholder="input.placeholderText"
                show-as-optional
                :validations="{
                  required: input.isRequired
                }"
              />
            </div>
          </template>

          <div class="layout layout--horizontal layout--horizontal-equal">
            <button
              class="button button--light"
              type="button"
              @click="$closeModal('iAmHere')"
            >
              Cancel
            </button>

            <button
              class="button button--primary"
              :class="{
                'button--loading': isNotifyingStaff
              }"
              type="submit"
            >
              I Am Here
            </button>
          </div>
        </validated-form>
      </div>
    </modal>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import http from '@/services/http';
  import md5 from 'md5';
  import { mapGetters } from 'vuex';
  import storage from '@/services/storage';



  export default {
    name: 'GuestArrivedButton',

    props: {
      autoOpen: {
        type: Boolean,
        default: false
      },
      order: {
        type: Object,
        required: true
      },
      receiptToken: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        details: {},
        hasNotifiedStaff: false,
        isNotifyingStaff: false
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),

      checkInOptions() {
        switch (this.order.pickupLocation) {
          case 'take-out':
            return this.merchant.options.insideCheckInOptions;

          case 'drive-through':
            return this.merchant.options.driveThroughCheckInOptions;

          default:
            /**
             * For merchants that use the "I Am Here" feature for "Text to Pay" orders,
             * there won't be any pickup location on the order, so we'll default to
             * using the the curbside check-in options for these orders.
             */
            return this.merchant.options.curbsideCheckInOptions;
        }
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.conditionallyOpenIamHereModal();
      },

      conditionallyOpenIamHereModal() {
        if (this.autoOpen && this.order.externalOrderId) {
          this.$openModal('iAmHere');
        }
      },

      async notifyStaffGuestIsAtLocation() {
        try {
          this.isNotifyingStaff = true;

          await http.post(`/cardfree-api/v1/receipt/${this.receiptToken}/notify/merchant`, {
            orderHash: md5(this.order.externalOrderId),
            vehicle: {
              guestId: storage.local.get('deviceId'),
              ...this.details
            }
          });

          this.hasNotifiedStaff = true;

          // this.$triggerGoogleTrackingEvent('IAmHere', 'Receipt');

          this.$triggerNewRelicEvent('IAmHere', 'Information', 'I Am Here Receipt');
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isNotifyingStaff = false;
        }
      }
    }
  };
</script>
